import React from "react";
import { m as motion } from "../../shared/components/Motion";
import { childVariantsSlow as childVariants } from "../../shared/utils";

const Info = ({ data }) => {
  // Custom variant for this component (different timing)
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.2, delayChildren: 0.2 },
    },
  };

  return (
    <motion.div
      className="about__info grid"
      initial="hidden"
      animate="visible"
      variants={containerVariants}
    >
      <motion.div className="about__box" variants={childVariants}>
        <i className="bx bx-award about__icon"></i>
        <h3 className="about__title">Experience</h3>
        <span className="about__subtitle">
          {data?.yearsExperience || "0"}+ Years working
        </span>
      </motion.div>

      <motion.div className="about__box" variants={childVariants}>
        <i className="bx bx-briefcase-alt about__icon"></i>
        <h3 className="about__title">Completed</h3>
        <span className="about__subtitle">
          {data?.completedProjects || "0"}+ Projects
        </span>
      </motion.div>

      <motion.div className="about__box" variants={childVariants}>
        <i className="bx bx-support about__icon"></i>
        <h3 className="about__title">Support</h3>
        <span className="about__subtitle">Online 24/7</span>
      </motion.div>
    </motion.div>
  );
};

export default Info;
